const locale = {
  placeholder: {
    spliter: ' / ',
    empty: {
      blur: '搜索 ',
      focus: {
        single: '输入搜索值，按回车确认',
        multiple: '输入单个搜索值或用半角“|”隔开多个搜索值，按回车确认'
      }
    },
    text: {
      single: '输入搜索值，按回车确认',
      multiple: '用半角“|”隔开各搜索值，按回车确认'
    },
    select: {
      single: '选择单个搜索值',
      multiple: '选择多个搜索值，按回车确认'
    }
  },
  filterDropdownLabel: '选择搜索类型',
  tagHoverTip: '单击可编辑，按回车确认',
  modalTip: {
    title: '帮助说明',
    th: {
      td1: '-',
      td2: '输入格式',
      td3: '举例',
      td4: '搜索框展示',
      td5: '说明'
    },
    tr1: {
      td1: '单个关键词',
      td2: '【关键词】',
      td3: '192.168.1.86',
      td4: '',
      td5: '过滤 输入匹配，包含“192.168.1.86”的IPv4'
    },
    tr2: {
      td1: '单选择项',
      td2: '【选择项】：【关键词】',
      td3: 'Instance ID: 750339712325',
      td4: '',
      td5: '过滤 “Instance ID“包含“1750339712325”的实例'
    },
    tr3: {
      td1: '多选择项',
      td2: '【选择项】：【关键词】【回车】【选择项】：【关键词】',
      td3: 'Instance ID: 750339712325<br/>Instance Name: S9F-MAD-A-02',
      td4: '',
      td5: '过滤 “Instance ID“包含“1750339712325”，且 “Instance Name“为”S9F-MAD-A-02“的实例'
    },
    tr4: {
      td1: '批量关键词',
      td2: '【选择项】：【关键词】｜【选择项】',
      td3: 'IPv4: 192.168.1.86 | 192.168.0.0',
      td4: '',
      td5: '过滤 “Ipv4“包含“192.168.1.86”，或 “192.168.0.0“的实例'
    },
    tr5: {
      td1: '粘贴字符',
      td2: '粘贴字符串',
      td3: '192.168.1.86<br/>192.168.0.0<br/>192.168.0.23',
      td4: '',
      td5: '过滤 “Ipv4“包含“192.168.1.86”，或 “192.168.0.0“，或 “192.168.0.23“的实例'
    }
  }
};
export default locale;